import React, { useMemo } from "react";
import Select from "react-select";
import styles from "./boomrx.module.scss";

function formatTeammateLabel(t, variant) {
  const name = (t.name || "").trim() || `User ${t.id}`;
  const parts = [name];
  if (t.isMainAdmin) {
    parts[0] = `${name} (Main Admin)`;
  }
  if (t.email) {
    parts.push(t.email);
  }
  if (variant === "provider" && t.npi) {
    parts.push(`NPI ${t.npi}`);
  }
  return parts.join(" — ");
}

function excludeSelected(list, selectedIds, currentValue) {
  const current = currentValue != null ? String(currentValue) : "";
  const taken = new Set(
    selectedIds
      .map((id) => (id != null ? String(id) : ""))
      .filter((id) => id && id !== current),
  );
  return list.filter((t) => !taken.has(String(t.id)));
}

export function BoomRXTeammateSelect({
  teammates,
  value,
  onChange,
  placeholder,
  isLoading,
  inputId,
  variant,
  excludeUserIds,
}) {
  const options = useMemo(() => {
    const pool = excludeSelected(teammates, excludeUserIds || [], value);
    return pool.map((t) => ({
      value: String(t.id),
      label: formatTeammateLabel(t, variant),
    }));
  }, [teammates, excludeUserIds, value, variant]);

  const selected = useMemo(() => {
    if (!value) {
      return null;
    }
    return (
      options.find((o) => o.value === String(value)) ||
      (() => {
        const t = teammates.find((x) => String(x.id) === String(value));
        return t
          ? { value: String(t.id), label: formatTeammateLabel(t, variant) }
          : null;
      })()
    );
  }, [value, options, teammates, variant]);

  return (
    <Select
      className={styles.teammateSelect}
      classNamePrefix="wellsyncSelect"
      inputId={inputId}
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : "")}
      isClearable
      isSearchable
      isLoading={!!isLoading}
      placeholder={placeholder}
      noOptionsMessage={() =>
        isLoading ? "Loading…" : "No teammates match your search"
      }
      filterOption={(candidate, rawInput) => {
        if (!rawInput) {
          return true;
        }
        const q = rawInput.toLowerCase();
        return (candidate.label || "").toLowerCase().indexOf(q) >= 0;
      }}
    />
  );
}

export default BoomRXTeammateSelect;
